import { z } from "zod";
import { customerOrderNotificationHistoryV1Schema } from "./book-notification-history.js";
import { adminUlidSchema } from "./admin-operations-core.js";
export const retainedOrderMessageSchema = z
    .object({
    physicalOrderId: adminUlidSchema,
    kind: z.string().min(1).max(100),
    templateRevision: z.string().regex(/^[A-Z0-9_.-]{1,80}$/u),
    subject: z.string().max(500),
    text: z.string().max(32000),
    html: z.string().max(100000),
    digestSha256: z.string().regex(/^[a-f0-9]{64}$/u),
})
    .strict();
export const adminOrderMessagesCommandSchema = z
    .object({ physicalOrderId: adminUlidSchema, cursor: z.string().max(4096).optional() })
    .strict();
export const adminTicketOrderMessagesCommandSchema = z
    .object({
    view: z.literal("ORDER_MESSAGES"),
    ticketId: adminUlidSchema,
    cursor: z.string().max(4096).optional(),
})
    .strict();
export const adminOrderMessagesResponseSchema = z
    .object({
    data: z
        .object({
        physicalOrderId: adminUlidSchema,
        ticketId: adminUlidSchema.nullable(),
        history: customerOrderNotificationHistoryV1Schema,
        renditions: z
            .array(z
            .object({
            recordId: z.string().regex(/^[a-f0-9]{64}$/u),
            state: z.enum(["RETAINED", "UNAVAILABLE_LEGACY"]),
            message: retainedOrderMessageSchema.nullable(),
        })
            .strict())
            .max(50),
        testClassification: z.enum(["TEST", "REAL", "UNKNOWN"]),
    })
        .strict(),
})
    .strict();
//# sourceMappingURL=admin-order-messages.js.map